export function memoize(fn, cache) {
    return (...args) => {
        let res;
        return cache.has(args)
            ? cache.get(args)
            : (cache.set(args, (res = fn.apply(null, args))), res);
    };
}
